<div class="fill-information" [formGroup]="fillInformationForm">
    @for (input of fillInformationStepInputs; track input.id) {
        @if (input.type === 'autocomplete') {
            <div>
                <label class="fill-information__label">{{ input.label }}</label>
                <app-autocomplete
                    [formControlName]="input.id"
                    [attr.data-testid]="input.id"
                    [loading]="isLoadingDealers()"
                    [options]="dealerOptions()"
                    (onSearch)="searchKey.set($event)"
                    [error]="getErrorMessage(input.id)"></app-autocomplete>
            </div>
        } @else {
            <ntv-input
                [formControlName]="input.id"
                [attr.data-testid]="input.id"
                [label]="input.label"
                [placeholder]="input.placeholder"
                [required]="input.required"
                [error]="getErrorMessage(input.id)"></ntv-input>
        }
    }
</div>
